/* oxlint-disable react/forbid-elements */
import * as React from 'react';

// Сейчас нет такой иконки в КИТ, если появится, то заменю svg на компонент
export function TableIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7 2H2V7H7V2ZM7 9H2V14H7V9ZM9 2H14V7H9V2ZM14 9H9V14H14V9Z" />
    </svg>
  );
}
